import React, { Component } from 'react'
import cx from 'classnames'
import za from 'za-helper'
import { ZAEnv, ZARef } from 'za-react'
import Button from '~/components/Button'
import { platform, universalOpenUrl } from '~/utils'
import styles from './index.css'

export default class Outlink extends Component {
  zaRef = React.createRef()
  handleClick = () => {
    za.trackEvent(this, { id: 2047 })
    // eslint-disable-next-line no-unused-expressions
    this.zaRef.current.trackEvent({
      eventType: 'Click',
      action: 'OpenUrl',
      elementLocation: { type: 'Button' },
    })
    const { landPageIOS, landPageAndroid } = this.props
    const landPage = platform === 'ios' ? landPageIOS : landPageAndroid
    universalOpenUrl(landPage)
  }

  render() {
    const {
      className,
      productImgUrl,
      productMainTitle,
      productViceTitle,
    } = this.props

    return (
      <div className={cx(styles.outlink, className)}>
        <div className={styles.outlinkInfo}>
          <img src={productImgUrl} alt="" className={styles.outlinkImage} />
          <div className={styles.outlinkDesc}>
            <header className={styles.outlinkTitle}>{productMainTitle}</header>
            <span className={styles.outlinkSubtitle}>{productViceTitle}</span>
          </div>
        </div>
        <ZAEnv block="activityCardButton">
          <ZARef ref={this.zaRef} />
          <Button onClick={this.handleClick}>点击观看</Button>
        </ZAEnv>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Conversion/Outlink/index.js